import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}><path fill="#1e1e1e" fillRule="evenodd" d="M.293.293a1 1 0 011.414 0L12 10.585 22.293.293a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L13.415 12l10.292 10.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L12 13.415 1.707 23.707a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L10.585 12 .293 1.707A1 1 0 01.21.387z" /></svg>);